import { render, staticRenderFns } from "./TheEditAttributeForm.vue?vue&type=template&id=aa31475c&scoped=true&"
import script from "./TheEditAttributeForm.vue?vue&type=script&lang=js&"
export * from "./TheEditAttributeForm.vue?vue&type=script&lang=js&"
import style0 from "./TheEditAttributeForm.vue?vue&type=style&index=0&id=aa31475c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa31475c",
  null
  
)

export default component.exports